import { ErrorBoundary } from '../components/ErrorBoundary.tsx';
import { Splitter } from '../components/Splitter.tsx';
import { useKeyboardShortcuts } from '../hooks/useKeyboardShortcuts.ts';
import { useUi } from '../state/ui-store.ts';
import { Dialogs } from './Dialogs.tsx';
import { Inspector } from './inspector/Inspector.tsx';
import { LibraryPanel } from './library/LibraryPanel.tsx';
import { Timeline } from './timeline/Timeline.tsx';
import { Topbar } from './Topbar.tsx';
import { Viewer } from './viewer/Viewer.tsx';

export function EditorLayout() {
  const { libraryWidth, inspectorWidth, timelineHeight, setPanelSize } = useUi();
  useKeyboardShortcuts(true);
  return (
    <div className="editor">
      <Topbar />
      <div className="editor-main">
        <div className="editor-upper">
          <div style={{ width: libraryWidth, flexShrink: 0, display: 'flex' }}>
            <ErrorBoundary area="Library">
              <LibraryPanel />
            </ErrorBoundary>
          </div>
          <Splitter
            orientation="vertical"
            size={libraryWidth}
            onResize={(s) => setPanelSize('libraryWidth', s)}
            min={220}
            max={640}
          />
          <ErrorBoundary area="Viewer">
            <Viewer />
          </ErrorBoundary>
          <Splitter
            orientation="vertical"
            size={inspectorWidth}
            direction={-1}
            onResize={(s) => setPanelSize('inspectorWidth', s)}
            min={260}
            max={640}
          />
          <div style={{ width: inspectorWidth, flexShrink: 0, display: 'flex' }}>
            <ErrorBoundary area="Inspector">
              <Inspector />
            </ErrorBoundary>
          </div>
        </div>
        <Splitter
          orientation="horizontal"
          size={timelineHeight}
          direction={-1}
          onResize={(s) => setPanelSize('timelineHeight', s)}
          min={180}
          max={window.innerHeight - 220}
        />
        <div style={{ height: timelineHeight, flexShrink: 0, display: 'flex' }}>
          <ErrorBoundary area="Timeline">
            <Timeline />
          </ErrorBoundary>
        </div>
      </div>
      <ErrorBoundary area="Dialog">
        <Dialogs />
      </ErrorBoundary>
    </div>
  );
}
